// extracted by mini-css-extract-plugin
export var navbarSubLink = "J_gb d_gb d_f4 d_0 d_cc d_dm d_bs d_bT";
export var menuLink = "J_v8 d_f0 d_dB";
export var subPageLink = "J_gf d_gf";
export var burger = "J_wy";
export var sublinkSize = "J_wz";
export var linkSize = "J_wB";
export var Link = "J_vH D_vH D_t1 D_vl";